module.exports = __webpack_public_path__ + "img/pexels-tiger-lily-4483610-com.f1337ac9.jpg";